<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/e22ICm/tc-custom/9781504033282.jpg?1704761784988" alt="This image is the cover for the book Dower House Mystery"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dower House Mystery
      </h1>
      <p class="bookDescription body article font2">
        <b>In this atmospheric tale from the author of the Miss Silver Mysteries, a widow is reunited with her girlhood love in a house haunted by all-too-human ghosts </b><br/>  <br/> They meet again in the dusk of a ruined garden. Amabel Grey hasn’t laid eyes on Julian Forsham in twenty years, not since she gave him up—the man she’d fallen passionately in love with—for the fiancé who needed her. Now an unexpected circumstance brings the British widow and the world-famous scientist together again.<br/>  <br/> Amabel’s nineteen-year-old daughter, Daphne, has been invited to join her friends—and the boy she adores—on a trip to Egypt. But she needs two hundred pounds from her mother. George Forsham is offering that exact sum to anyone willing to stay six months at Dower House, the centuries-old estate in the English countryside where Amabel and Julian first met. The fact that the overgrown, sadly neglected house is rumored to be haunted doesn’t deter Amabel. Until strange things start happening . . .<br/>  <br/> The mewing of a cat that doesn’t exist, the sound of flapping wings, someone crying in the dark. Are restless spirits walking the night? Or is there a rational explanation? Plunged into deadly danger, Amabel could lose her second chance with the man she never stopped loving.<br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Patricia  Wentworth
      </h2>
      
      <p class="authorDescription body article">Patricia Wentworth (1878&ndash;1961) was one of the masters of classic English mystery writing. Born in India as Dora Amy Elles, she began writing after the death of her first husband, publishing her first novel in 1910. In the 1920s, she introduced the character who would make her famous: Miss Maud Silver, the former governess whose stout figure, fondness for Tennyson, and passion for knitting served to disguise a keen intellect. Along with Agatha Christie&rsquo;s Miss Marple, Miss Silver is the definitive embodiment of the English style of cozy mysteries.<BR></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?01dea193